import { render } from "./AreaSelector.vue?vue&type=template&id=8f765722&scoped=true&ts=true"
import script from "./AreaSelector.vue?vue&type=script&lang=ts"
export * from "./AreaSelector.vue?vue&type=script&lang=ts"

import "./AreaSelector.vue?vue&type=style&index=0&id=8f765722&lang=scss&scoped=true"
import "./AreaSelector.vue?vue&type=style&index=1&id=8f765722&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/hw-employment-front-end-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f765722"]])

export default __exports__